import { ColDef, ValueGetterParams } from "ag-grid-community";
import { CustomCellRendererProps } from "ag-grid-react";
import { NotificationsCell } from "@/components/pages/common/ag-grid/components/common-cell-renderers/notifications-cell/NotificationsCell";

const valueGetter = ({ data }: ValueGetterParams<any>) => {
  const integrationName = data?.integrations?.reduce((acc: any, cur: any) => {
    return acc + " " + cur.name;
  }, "");
  const email = data?.emails?.to?.join(" ");
  return `${integrationName} ${email ?? ""} `;
};

const comparator: ColDef["comparator"] = (_, __, nodeA, nodeB) => {
  const currentIntegrationName = nodeA?.data?.integrations?.at(0)?.name;
  const currentEmail = nodeA?.data?.emails?.to?.at(0);
  const current = (currentIntegrationName ?? currentEmail ?? "").toLowerCase();

  const nextIntegrationName = nodeB?.data?.integrations?.at(0)?.name ?? "";
  const nextEmail = nodeB?.data?.emails?.to?.at(0);
  const next = (nextIntegrationName ?? nextEmail ?? "").toLowerCase();

  return current > next ? 1 : -1;
};

export const notificationMethodColumnDef: ColDef = {
  field: "integrations",
  headerName: "Notification Method",
  cellRenderer: ({ data }: CustomCellRendererProps) => {
    const integrations = data?.integrations;
    const emails = data?.emails;

    return (
      <NotificationsCell emails={emails} integrations={integrations ?? []} />
    );
  },
  minWidth: 210,
  comparator,
  valueGetter,
};
